import { tns } from 'tiny-slider/src/tiny-slider';
const relatedArticles = document.querySelectorAll('.component-related-articles');
const relatedArticlesSlider = document.querySelectorAll('.component-related-articles__slider');

//Initiate slider for for mobile for each instance in case of multiples
if(relatedArticles.length > 0) {
    relatedArticlesSlider.forEach(slider => {
        let sliderRelatedArticles = tns({
            container: slider,
            items: 1,
            edgePadding: 25,
            controls: false,
            nav: true,
            navPosition: 'bottom',
            center: true,
            loop: false,
            swipeAngle: false,
            speed: 400,
            preventScrollOnTouch: 'auto',
            autoplay: false,
            responsive: {
                768: {
                    disable: true
                }
            }
        });
        window.addEventListener("resize", function () {
            sliderRelatedArticles.destroy();
            sliderRelatedArticles = sliderRelatedArticles.rebuild();
        });
    });
}